export const brandList = [
  "IMARA",
  "House of Pataudi",
  "The White Willow",
  "Dupatta Bazaar",
  "Manyavar",
  "Wintage",
  "Geroo Jaipur",
  "The Indian Garage Co",
  "Anouk",
  "SALWAR STUDIO",
  "Clora Creation",
  "Libas",
  "Global Desi",
  "Aj DEZInES",
  "612 league",
  "Jompers",
  "SOJANYA",
  "Story@home",
  "Ethnicity",
  "British Club",
  "Svanik",
  "Rohit Bal Limited",
  "Ishin",
  "See Designs",
  "Biba",
  "Purple State",
  "Shree",
  "SG YUVRAJ",
  "Sangria",
  "even",
  "Rajesh Silk Mills",
  "Manu",
  "I AM FOR YOU",
  "CHRISTY",
  "Abhiyuthan",
  "Abhishti",
  "I Know",
  "pspeaches",
  "HERE&NOW",
  "Soch",
  "Hangup",
  "Twisha",
  "Fabindia",
  "Kira Plus",
  "Nayo",
  "K&U",
  "AKS",
  "GERUA",
  "VASTRAMAY",
  "TREEMODA",
  "RARE ROOTS",
  "Freehand",
  "YK",
  "BownBee",
  "DEYANN",
  "RAJUBHAI HARGOVINDAS",
  "Vishudh",
  "KAANCHIE NANGGIA",
  "Varanga",
  "The Magic Wand",
  "Alina decor",
  "Shakumbhari",
  "Style Quotient",
  "Cross Court",
  "Inddus",
  "all about you",
  "Gatha",
  "Zotw",
  "AKKRITI BY PANTALOONS",
  "Peaches",
  "Be Indi",
  "SHOWOFF",
  "Aarika",
  "JBN Creation",
  "Divine Casa",
  "Bollywood Vogue",
  "AURELIA",
  "JAINISH",
  "indus route by Pantaloons",
  "Anekaant",
  "Arch Elements",
  "BOMBAY DYEING",
  "MASPAR",
  "Dazzio",
  "Hypernation",
  "Ira Soleil",
  "LilPicks",
  "Jansons",
  "Ethnix by Raymond",
  "DDecor",
  "La Firangi",
  "INDYA",
  "Sanjhi",
  "irin",
  "L.A. SEVEN",
  "Khoday Williams",
  "Bitterlime",
  "SWAYAM",
  "Very Me",
  "BETTY",
  "Banarasi Style",
  "Moda Rapido",
  "akavya",
  "Rangriti",
  "KISAH",
  "Chitwan Mohan",
  "RG DESIGNERS",
  "Shaily",
  "Ritu Kumar",
  "Melange by Lifestyle",
  "Sanwara",
  "Bitiya by Bhama",
  "Manish Creations",
  "Trend Arrest",
  "A.T.U.N All Things Uber Nice",
  "ANAISA",
  "ROYAL KURTA",
  "CHILL WINSTON",
  "W",
  "Trident",
  "Naari",
  "TAG 7",
  "Peter England",
  "Fusion Beats",
  "Jaipur Kurti",
  "Terry Fator",
  "SASSAFRAS",
  "Nick&Jess",
  "Tiber Taber",
  "EverHOME",
  "Nature Casuals",
  "IVOC",
  "Hubberholme",
  "Rajasthan Decor",
  "Aasvaa",
  "PIVOTO",
  "Pantaloons Junior",
  "TABARD",
  "KID1",
  "PINKSKY",
  "GMF",
  "Portico New York",
  "SEJ by Nisha Gupta",
  "Raymond Home",
  "Routeen",
  "Juniper",
  "URBAN DREAM",
  "Silk India",
  "Indibelle",
  "United Colors of Benetton",
  "Sringam",
  "Independence Club",
  "TJORI",
  "Taavi",
  "Alom",
  "Blue Saint",
  "MABISH by Sonal Jain",
  "SWHF",
  "ADIVA",
  "Yufta",
  "Cottinfab",
  "Chhabra 555",
  "MOHANLAL SONS",
  "Aksara",
  "IndusDiva Loomnic",
  "Castle",
  "TOZZI",
  "WoowZerz",
  "Kidling",
  "MAFATLAL",
  "Tulsattva",
  "Prayyan",
  "Raas",
  "TATTVA",
  "MARK HOME",
  "Blissta",
  "Jeetethnics",
  "studio rasa",
  "Vivids India",
  "WEAVERS VILLA",
  "Colour Me by Melange",
  "Shaftesbury London",
  "Kuons Avenue",
  "Faserz",
  "Dreamscape",
  "SPACES",
  "STREET 9",
  "Campana",
  "RIYA",
  "Dennis Morton",
  "LUXURAZI",
  "THE SILHOUETTE STORE",
  "WONDERMOM",
  "RAISIN",
  "Raymond Ethnix",
  "Athena",
  "SYONN",
  "AKS Couture",
  "Rajyog",
  "Gini and Jony",
  "Pluchi",
  "Azira",
  "Satrani",
  "SUTRAM",
  "Citypret",
  "RIKIDOOS",
  "RANGMANCH BY PANTALOONS",
  "Indo Era",
  "PAROKSH",
  "CORE Designed by SPACES",
  "Mangalyam British Club",
  "rangeelo rajasthan",
  "Bene Kleed",
  "NEUDIS",
  "VULCAN",
  "anayna",
  "Ayaany",
  "SOUNDARYA",
  "Globus",
  "MR BUTTON",
  "Home Sizzler",
  "Laabha",
  "Huesland",
  "Faballey Indya",
  "AASI - HOUSE OF NAYO",
  "Aura",
  "shiloh",
  "Yellow Kite",
  "Noi",
  "Peter England Casuals",
  "Myshka",
  "PITARA",
  "V SALES",
  "CHOKORE",
  "mf",
  "Indian Poshakh",
  "Louis Park",
  "Kira",
  "Saree mall",
  "BIANCA",
  "JADE BLUE",
  "Home Ecstasy",
  "Boutique Living India",
  "Shree Shubh",
  "PANIT",
  "LOCOMOTIVE",
  "Celio",
  "A Little Fable",
  "Chennis",
  "Toshee",
  "U.S. Polo Assn. Kids",
  "Indian Attire",
  "BLUSH",
  "Stylee LIFESTYLE",
  "Salona Bichona",
  "UNTUNG",
  "Fuzion Couture",
  "La Bele",
  "Jack & Jones",
  "Nation Polo Club",
  "ROMEE",
  "PIZUNA LINENS",
  "A Homes Grace",
  "Breakbounce",
  "SG LEMAN",
  "Cortina",
  "Amora",
  "Saadgi",
  "Aujjessa",
  "Rodamo",
  "SOHO By MAFATLAL",
  "AgrohA",
  "House This",
  "Crafts collection",
  "Styles Closet",
  "Larwa",
  "Mirage",
  "TALES & STORIES",
  "Lombard",
  "STELLAR HOME",
  "Drama Sisters",
  "Yuris",
  "Fairies Forever",
  "My Little Lambs",
  "Ahmedabad Cotton",
  "breya",
  "Label Ritu Kumar",
  "WESTCLO",
  "20Dresses",
  "Imfashini",
  "Clovia",
  "Stylo Bug",
  "pinkshink",
  "Voi Jeans",
  "Aarrah",
  "HK colours of fashion",
  "Rain & Rainbow",
  "Janasya",
  "Vozaf",
  "Shahjada",
  "WELHOME",
  "Yosshita & Neha",
  "Pannkh",
  "ANAN",
  "Desi Weavess",
  "Sera",
  "Honey by Pantaloons",
  "Spread",
  "John Pride",
  "MBE",
  "RENE",
  "aasi",
  "MOR INTERNATIONAL",
  "Rock-a-Bye Baby",
  "Cottonworld",
  "Bronz",
  "Alena",
  "COTTON ON",
  "TRISHAA BY PANTALOONS",
  "KAY",
  "aLL",
  "THE BABY ATELIER",
  "MANVAA",
  "Splash",
  "Mitera",
  "AND",
  "VividArtsy",
  "Ahalyaa",
  "Indigo Nation",
  "Solemio",
  "9rasa",
  "SHINGORA",
  "Kvsfab",
  "RIVI",
  "Belle Fille",
  "Zivame",
  "RANGRAGE",
  "trueBrowns",
  "Florence",
  "The Chennai Silks",
  "HIGHLANDER",
  "Pisara",
  "Priyaasi",
  "Soumya",
  "Athom Trendz",
  "Balance by Rohit Bal",
  "rasm",
  "Sethukrishna",
  "Folklore",
  "Travel Blue",
  "De Moza",
  "IMYOUNG",
  "StyleStone",
  "Tokyo Talkies",
  "Toss Winner",
  "Khushal K",
  "American Eye",
  "AASK",
];
